interface DrawAnglesOpts {
    angle?: number;
    size?: number;
    radius?: number;
    strokeColor?: string;
    strokeWidth?: number;
    arcColor?: string;
}

export function drawAngles(canvas: HTMLCanvasElement, opts?: DrawAnglesOpts): void {
    if (!(canvas instanceof HTMLCanvasElement)) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const {
        angle = 45,
        size = 400,
        radius = 140,
        strokeColor = '#333333',
        strokeWidth = 2,
        arcColor = '#f4a261',
    } = opts ?? {};

    const dpr = (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
    canvas.width = Math.round(size * dpr);
    canvas.height = Math.round(size * dpr);
    canvas.style.width = `${size}px`;
    canvas.style.height = `${size}px`;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    ctx.clearRect(0, 0, size, size);

    const cx = size / 2;
    const cy = size / 2;

    const rad = (angle * Math.PI) / 180;

    if (angle > 0) {
        ctx.beginPath();
        ctx.moveTo(cx, cy);
        if (angle >= 360) {
            ctx.arc(cx, cy, radius * 0.4, 0, Math.PI * 2);
        } else {
            ctx.arc(cx, cy, radius * 0.4, 0, -rad, true);
        }
        ctx.closePath();
        ctx.fillStyle = arcColor;
        ctx.globalAlpha = 0.2;
        ctx.fill();
        ctx.globalAlpha = 1.0;

        ctx.beginPath();
        if (angle >= 360) {
            ctx.arc(cx, cy, radius * 0.4, 0, Math.PI * 2);
        } else {
            ctx.arc(cx, cy, radius * 0.4, 0, -rad, true);
        }
        ctx.strokeStyle = arcColor;
        ctx.lineWidth = 2;
        ctx.stroke();
    }

    ctx.strokeStyle = strokeColor;
    ctx.lineWidth = strokeWidth;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';

    ctx.beginPath();
    ctx.moveTo(cx, cy);
    ctx.lineTo(cx + radius, cy);
    ctx.stroke();

    ctx.beginPath();
    ctx.moveTo(cx, cy);
    ctx.lineTo(cx + radius * Math.cos(-rad), cy + radius * Math.sin(-rad));
    ctx.stroke();

    ctx.beginPath();
    ctx.arc(cx, cy, 4, 0, Math.PI * 2);
    ctx.fillStyle = strokeColor;
    ctx.fill();

    ctx.fillStyle = strokeColor;
    ctx.font = 'bold 16px sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    const labelAngle = -rad / 2;
    const labelDist = radius * 0.55;
    const lx = cx + labelDist * Math.cos(labelAngle);
    const ly = cy + labelDist * Math.sin(labelAngle);

    if (angle > 15) {
        ctx.fillText(`${angle}°`, lx, ly);
    } else if (angle > 0) {
        const outerLx = cx + (radius + 30) * Math.cos(labelAngle);
        const outerLy = cy + (radius + 30) * Math.sin(labelAngle);
        ctx.fillText(`${angle}°`, outerLx, outerLy);
    }
}

export const angles = {
    key: 'angles',
    name: 'Angle Visualiser',
    draw: drawAngles,
    meta: {
        title: 'Angle Visualiser',
        description: 'Visualise angles from 0 to 360 degrees.',
        icon: '∠',
        href: '/methods/angles',
    },
};

export default drawAngles;
